import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center p-4">
          <div className="bg-surface-container-high p-8 border border-error/30 max-w-2xl w-full text-center">
            <span className="material-symbols-outlined text-6xl text-error mb-6">warning</span>
            <h1 className="text-4xl font-headline font-black uppercase italic mb-4 text-white">System Malfunction</h1>
            <p className="font-label text-on-surface-variant mb-8">
              A critical error occurred while rendering this interface.
            </p>
            <div className="bg-surface-container-low p-4 text-left overflow-x-auto mb-8 border border-white/10">
              <pre className="text-xs text-error font-body">
                {this.state.error?.message}
              </pre>
            </div>
            <button
              onClick={() => window.location.href = '/'}
              className="px-8 py-3 bg-secondary text-on-secondary font-black uppercase tracking-widest hover:bg-white transition-colors"
            >
              Reboot Interface
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
